// extracted by mini-css-extract-plugin
export default {"mealTable":"jnY5KYekDAqgsVZ7F6H8","workoutTable":"ML29RfJqngI9B47zr0tz"};